import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreatePlot = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 494,
	height: 259,
	viewBox: "0 0 494 259",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M380.047 10.0537C382.42 10.1237 384.775 10.2619 387.11 10.4697L387.066 10.9678C389.419 11.1771 391.751 11.456 394.062 11.8018L394.135 11.3086C396.481 11.6597 398.804 12.0795 401.103 12.5664L401 13.0547C403.309 13.5439 405.593 14.1012 407.85 14.7236L407.981 14.2432C410.265 14.873 412.52 15.5688 414.745 16.3301L414.584 16.8018C416.813 17.5645 419.012 18.3925 421.179 19.2832L421.368 18.8223C423.556 19.7219 425.711 20.685 427.83 21.71L427.613 22.1592C429.733 23.1846 431.818 24.2722 433.864 25.4189L434.107 24.9834C436.169 26.1389 438.193 27.3546 440.175 28.6279L439.906 29.0479C441.886 30.3194 443.824 31.6485 445.719 33.0332L446.012 32.6309C447.919 34.0244 449.782 35.4737 451.599 36.9766L451.281 37.3613C453.093 38.8599 454.859 40.4117 456.575 42.0146L456.915 41.6504C458.64 43.2614 460.316 44.9237 461.941 46.6348L461.581 46.9775C463.199 48.6812 464.765 50.434 466.278 52.2324L466.659 51.9111C468.178 53.7159 469.642 55.567 471.051 57.4619L470.652 57.7598C472.053 59.6438 473.397 61.5714 474.684 63.54L475.1 63.2676C476.389 65.2404 477.62 67.254 478.79 69.3066L478.358 69.5547C479.52 71.5927 480.622 73.669 481.661 75.7812L482.107 75.5605C483.147 77.6736 484.123 79.8226 485.036 82.0049L484.577 82.1973C485.481 84.3586 486.321 86.5534 487.096 88.7783L487.565 88.6133C488.339 90.8347 489.047 93.0862 489.687 95.3662L489.207 95.502C489.839 97.7557 490.405 100.037 490.902 102.344L491.39 102.238C491.885 104.536 492.313 106.858 492.67 109.203L492.176 109.278C492.527 111.587 492.812 113.919 493.024 116.271L493.521 116.226C493.732 118.561 493.873 120.916 493.944 123.289L493.447 123.304C493.482 124.477 493.5 125.654 493.5 126.836C493.5 128.018 493.482 129.196 493.447 130.369L493.944 130.383C493.873 132.755 493.732 135.11 493.521 137.445L493.024 137.401C492.812 139.753 492.527 142.085 492.176 144.395L492.67 144.469C492.313 146.814 491.885 149.136 491.39 151.433L490.902 151.329C490.405 153.636 489.839 155.917 489.207 158.171L489.687 158.305C489.047 160.585 488.339 162.836 487.565 165.058L487.096 164.895C486.321 167.119 485.481 169.313 484.577 171.475L485.036 171.667C484.124 173.849 483.147 175.998 482.107 178.11L481.661 177.891C480.622 180.003 479.52 182.08 478.358 184.118L478.79 184.364C477.62 186.417 476.39 188.431 475.101 190.403L474.684 190.132C473.397 192.101 472.053 194.029 470.652 195.913L471.051 196.21C469.642 198.105 468.178 199.956 466.659 201.761L466.278 201.44C464.765 203.239 463.199 204.991 461.581 206.694L461.941 207.037C460.317 208.748 458.64 210.41 456.915 212.021L456.575 211.657C454.858 213.26 453.093 214.813 451.281 216.312L451.599 216.694C449.782 218.197 447.919 219.647 446.012 221.041L445.719 220.639C443.824 222.023 441.885 223.353 439.906 224.624L440.175 225.043C438.192 226.317 436.169 227.532 434.106 228.688L433.864 228.254C431.818 229.401 429.733 230.488 427.613 231.514L427.83 231.962C425.711 232.987 423.556 233.949 421.368 234.849L421.179 234.389C419.012 235.279 416.813 236.107 414.584 236.87L414.745 237.341C412.52 238.102 410.265 238.799 407.981 239.429L407.85 238.949C405.593 239.572 403.309 240.129 401 240.618L401.103 241.104C398.804 241.591 396.481 242.012 394.135 242.363L394.062 241.87C391.751 242.216 389.419 242.495 387.066 242.704L387.111 243.202C384.776 243.41 382.42 243.547 380.047 243.617L380.033 243.12C378.86 243.155 377.682 243.172 376.5 243.172C375.318 243.172 374.14 243.155 372.967 243.12L372.952 243.617C370.579 243.547 368.223 243.41 365.888 243.202L365.934 242.704C363.581 242.495 361.249 242.216 358.938 241.87L358.864 242.363C356.518 242.012 354.195 241.591 351.896 241.104L352 240.618C349.691 240.129 347.407 239.572 345.15 238.949L345.018 239.429C342.734 238.799 340.479 238.102 338.254 237.341L338.416 236.87C336.187 236.107 333.988 235.279 331.821 234.389L331.631 234.849C329.443 233.949 327.288 232.987 325.169 231.962L325.387 231.514C323.267 230.488 321.182 229.401 319.136 228.254L318.893 228.688C316.83 227.532 314.807 226.317 312.824 225.043L313.094 224.624C311.115 223.353 309.176 222.023 307.281 220.639L306.986 221.04C305.08 219.647 303.217 218.197 301.4 216.694L301.719 216.312C299.907 214.813 298.142 213.26 296.425 211.657L296.084 212.021C294.359 210.41 292.682 208.748 291.058 207.037L291.419 206.694C289.801 204.991 288.235 203.239 286.722 201.44L286.34 201.761C284.821 199.956 283.356 198.104 281.947 196.209L282.348 195.913C280.947 194.029 279.603 192.101 278.316 190.132L277.898 190.403C276.61 188.431 275.379 186.417 274.209 184.364L274.642 184.118C273.48 182.08 272.378 180.003 271.339 177.891L270.892 178.11C269.852 175.998 268.875 173.849 267.963 171.667L268.423 171.475C267.519 169.313 266.679 167.119 265.904 164.895L265.434 165.058C264.661 162.836 263.952 160.585 263.312 158.305L263.793 158.171C263.161 155.917 262.595 153.636 262.098 151.329L261.609 151.433C261.114 149.136 260.686 146.814 260.329 144.469L260.824 144.395C260.473 142.085 260.188 139.753 259.976 137.401L259.479 137.445C259.267 135.11 259.126 132.755 259.055 130.383L259.553 130.369C259.518 129.196 259.5 128.018 259.5 126.836C259.5 125.654 259.518 124.477 259.553 123.304L259.055 123.289C259.126 120.916 259.267 118.561 259.479 116.226L259.976 116.271C260.188 113.919 260.473 111.587 260.824 109.278L260.329 109.203C260.686 106.858 261.114 104.536 261.609 102.238L262.098 102.344C262.595 100.037 263.161 97.7557 263.793 95.502L263.312 95.3662C263.952 93.0863 264.661 90.8347 265.434 88.6133L265.904 88.7783C266.679 86.5534 267.519 84.3586 268.423 82.1973L267.963 82.0049C268.876 79.8226 269.852 77.6735 270.892 75.5605L271.339 75.7812C272.378 73.669 273.48 71.5927 274.642 69.5547L274.209 69.3066C275.379 67.254 276.61 65.2404 277.899 63.2676L278.316 63.54C279.603 61.5714 280.947 59.6438 282.348 57.7598L281.948 57.4619C283.357 55.567 284.821 53.7159 286.34 51.9111L286.722 52.2324C288.235 50.4341 289.801 48.6812 291.419 46.9775L291.058 46.6348C292.683 44.9237 294.359 43.2614 296.084 41.6504L296.425 42.0146C298.141 40.4117 299.907 38.8599 301.719 37.3613L301.4 36.9766C303.217 35.4737 305.08 34.0245 306.987 32.6309L307.281 33.0332C309.176 31.6485 311.114 30.3194 313.094 29.0479L312.824 28.6279C314.806 27.3545 316.83 26.1389 318.892 24.9834L319.136 25.4189C321.182 24.2722 323.267 23.1846 325.387 22.1592L325.169 21.71C327.288 20.685 329.443 19.7219 331.631 18.8223L331.821 19.2832C333.988 18.3925 336.187 17.5645 338.416 16.8018L338.254 16.3301C340.479 15.5688 342.734 14.873 345.018 14.2432L345.15 14.7236C347.407 14.1012 349.691 13.5439 352 13.0547L351.896 12.5664C354.195 12.0795 356.518 11.6597 358.864 11.3086L358.938 11.8018C361.249 11.456 363.581 11.1771 365.934 10.9678L365.889 10.4697C368.224 10.2619 370.579 10.1237 372.952 10.0537L372.967 10.5518C374.14 10.5172 375.318 10.5 376.5 10.5C377.682 10.5 378.86 10.5172 380.033 10.5518L380.047 10.0537Z",
			stroke: "#BEBEBE",
			strokeDasharray: "7 7"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_429_13934)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 66,
					y: 55,
					width: 100,
					height: 100,
					rx: 8,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 66.5,
					y: 55.5,
					width: 99,
					height: 99,
					rx: 7.5,
					stroke: "black",
					strokeOpacity: .12
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M102.25 124.692V104.308H109.75V124.692H102.25ZM114.125 124.692V91.8078H121.625V124.692H114.125ZM126 124.692V114.308H133.5V124.692H126Z",
					fill: "#BEBEBE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M142.25 138.25H93.5C92.5054 138.25 91.5516 137.855 90.8483 137.152C90.1451 136.448 89.75 135.495 89.75 134.5V85.75H93.5V134.5H142.25V138.25Z",
					fill: "#D5DADC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 66,
					y: 55,
					width: 100,
					height: 10,
					fill: "#64BDE1"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_d_429_13934)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 206,
					y: 103,
					width: 100,
					height: 100,
					rx: 8,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.5,
					y: 103.5,
					width: 99,
					height: 99,
					rx: 7.5,
					stroke: "black",
					strokeOpacity: .12
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M267.25 127.25V123.5H248.5V127.25H256V131H248.5V153.5H256V157.25H248.5V161H267.25V157.25H259.75V153.5H267.25V131H259.75V127.25H267.25ZM252.25 149.75V144.125H263.5V149.75H252.25ZM263.5 140.375H252.25V134.75H263.5V140.375Z",
					fill: "#BEBEBE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M282.25 172.25H233.5C232.505 172.25 231.552 171.855 230.848 171.152C230.145 170.448 229.75 169.495 229.75 168.5V119.75H233.5V168.5H282.25V172.25Z",
					fill: "#D5DADC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206,
					y: 193,
					width: 100,
					height: 10,
					fill: "#06709B"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_d_429_13934)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 346,
					y: 55,
					width: 100,
					height: 100,
					rx: 8,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 346.5,
					y: 55.5,
					width: 99,
					height: 99,
					rx: 7.5,
					stroke: "black",
					strokeOpacity: .12
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M422.25 140.25H373.5C372.505 140.25 371.552 139.855 370.848 139.152C370.145 138.448 369.75 137.495 369.75 136.5V87.75H373.5V136.5H422.25V140.25Z",
					fill: "#D5DADC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M384 129.001L384.3 129",
					stroke: "#8C8C8C",
					strokeWidth: 6,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M396 117.001L396.3 117",
					stroke: "#BEBEBE",
					strokeWidth: 6,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M384 117.001L384.3 117",
					stroke: "#BEBEBE",
					strokeWidth: 6,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M396 105.001L396.3 105",
					stroke: "#BEBEBE",
					strokeWidth: 6,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M408 108.001L408.3 108",
					stroke: "#BEBEBE",
					strokeWidth: 6,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M411 96.0006L411.3 96",
					stroke: "#8C8C8C",
					strokeWidth: 6,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 346,
					y: 55,
					width: 100,
					height: 10,
					fill: "#064C68"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 231,
			cy: 231,
			r: 5,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 141,
			cy: 254,
			r: 4.5,
			stroke: "#BEBEBE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 48,
			cy: 244,
			r: 5,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 236,
			cy: 28,
			r: 4.5,
			stroke: "#BEBEBE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 141,
			cy: 5,
			r: 5,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 48,
			cy: 15,
			r: 4.5,
			stroke: "#BEBEBE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5,
			cy: 167,
			r: 4.5,
			stroke: "#BEBEBE"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_429_13934",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 72,
			width: 16,
			height: 16,
			children: /* @__PURE__ */ _jsx("rect", {
				y: 72,
				width: 16,
				height: 16,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_429_13934)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M7.11685 80.8834H3.01318V79.1167H7.11685V75.013H8.88352V79.1167H12.9872V80.8834H8.88352V84.987H7.11685V80.8834Z",
				fill: "#BEBEBE"
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_429_13934",
				x: 43,
				y: 36,
				width: 146,
				height: 146,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 3,
						operator: "dilate",
						in: "SourceAlpha",
						result: "effect1_dropShadow_429_13934"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 10 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_429_13934"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_429_13934",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_429_13934",
				x: 183,
				y: 84,
				width: 146,
				height: 146,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 3,
						operator: "dilate",
						in: "SourceAlpha",
						result: "effect1_dropShadow_429_13934"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 10 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_429_13934"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_429_13934",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_429_13934",
				x: 323,
				y: 36,
				width: 146,
				height: 146,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 3,
						operator: "dilate",
						in: "SourceAlpha",
						result: "effect1_dropShadow_429_13934"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 10 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_429_13934"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_429_13934",
						result: "shape"
					})
				]
			})
		] })
	]
});
export default SvgCreatePlot;
